import { useEffect, useState } from "react";
import { animate, motion } from "framer-motion";
import { Send } from "lucide-react";

const AnimatedNumber = ({ value, testId }) => {
  const [shown, setShown] = useState(value);
  useEffect(() => {
    const controls = animate(shown, value, { duration: 0.5, ease: "easeOut", onUpdate: (v) => setShown(Math.round(v)) });
    return () => controls.stop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return <span data-testid={testId}>£{shown.toLocaleString("en-GB")}</span>;
};

export const SummaryBar = ({ totals, onSend }) => (
  <div className="sticky bottom-4 z-30 mt-14 pr-16 sm:bottom-6 sm:pr-20 lg:pr-0" data-testid="build-summary-bar">
    <div className="mx-auto flex max-w-4xl items-center gap-4 rounded-2xl border border-white/10 bg-ink/90 px-4 py-3 text-paper shadow-[0_24px_60px_-20px_rgba(26,47,36,0.7)] backdrop-blur-xl sm:gap-8 sm:px-8 sm:py-4">
      <div>
        <p className="whitespace-nowrap text-[9px] font-semibold uppercase tracking-[0.2em] text-paper/50 sm:text-[10px] sm:tracking-[0.25em]">One-off</p>
        <p className="whitespace-nowrap font-display text-xl sm:text-3xl" data-testid="build-one-off-total">
          <AnimatedNumber value={totals.oneOff} testId="build-one-off-value" />
          {totals.isQuote && <span className="ml-1 text-xs sm:text-base text-paper/70">+ quote</span>}
        </p>
      </div>
      <div className="hidden h-10 w-px bg-paper/15 sm:block" />
      <div>
        <p className="whitespace-nowrap text-[9px] font-semibold uppercase tracking-[0.2em] text-paper/50 sm:text-[10px] sm:tracking-[0.25em]"><span className="sm:hidden">Monthly</span><span className="hidden sm:inline">Monthly retainer</span></p>
        <motion.p
          key={totals.monthly}
          initial={{ color: "#F5D48A" }}
          animate={{ color: "#F7F9F7" }}
          transition={{ duration: 1.2 }}
          className="whitespace-nowrap font-display text-xl sm:text-3xl"
          data-testid="build-monthly-total"
        >
          <AnimatedNumber value={totals.monthly} testId="build-monthly-value" />
          <span className="text-base text-paper/70">/mo</span>
        </motion.p>
      </div>
      <button
        type="button"
        onClick={onSend}
        data-testid="build-send-list-button"
        className="ml-auto inline-flex shrink-0 items-center gap-2 rounded-full bg-paper px-4 py-2.5 text-sm font-medium text-jade transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-white sm:px-6 sm:py-3"
      >
        <Send className="h-4 w-4" /> <span className="hidden sm:inline">Send my list</span><span className="sm:hidden">Send</span>
      </button>
    </div>
  </div>
);
